module.exports = __webpack_public_path__ + "img/horizontal_6_5_5.868d7de9.png";